module.exports = __webpack_public_path__ + "static/media/Dayly_ios_4_preview.b66981fa.jpg";